import React, { useEffect, useState } from "react";

import AcessarMI from "components/layout/home/AcessarMI";
import StoreFront from "assets/icons/store.svg";

import ResetPassword from "components/layout/home/AcessarMI/ResetPassword";

import FormBoletoRapido from "components/FormBoletoRapido";

import {
  AlignLogoMobile,
  AlignLogoWeb,
  Banner,
  Container,
  Content,
  ContentAlign,
  ContentAlignLogin,
  ContentAlignLogo,
  ContentBanner,
  ContentImages,
  ContentLogin,
  ContentLoginWrapper,
  ContentLogo,
  ContentLogoMobile,
  DegradeDesktop,
  Image,
  ImageTextWrapper,
  LinkBanner,
  Logo,
  TextBanner,
  TextLogoMobileWrapper,
  TextMobileWrapper,
  TextWeb,
  TextWebWrapper,
  TitleMobileWrapper,
  TitleWeb,
} from "./styles";

const images = [
  "/static/login/1.png",
  "/static/login/2.png",
  "/static/login/3.png",
  "/static/login/4.png",
  "/static/login/5.png",
];

const Login = (): JSX.Element => {
  const [imageActive, setImageActive] = useState(1);
  const [showModalResetPass, setShowModalRestPass] = useState(false);

  const showBoletoRapido = true;

  useEffect(() => {
    sessionStorage.removeItem("@UltragazEmpresarial:X-Mfa-Login");
    setInterval(() => {
      setImageActive((prev) => {
        if (prev === images?.length) {
          return 1;
        }
        return prev + 1;
      });
    }, 4000);
  }, []);

  return (
    <>
      <Container>
        <DegradeDesktop />
        <Content>
          <ContentLogo>
            <Logo
              src="/static/ultragaz-logo-white-somando-energia.png"
              alt="Logo Ultragaz branca"
            />
            <ContentAlignLogo>
              <AlignLogoWeb>
                <TitleWeb>Portal Minha Ultragaz</TitleWeb>
                <TextWebWrapper>
                  <img
                    src={StoreFront}
                    alt="Portal Minha Ultragaz"
                    width={40}
                  />
                  <TextWeb>
                    Feito para moradores de condomínios e lojistas com medição
                    individualizada
                  </TextWeb>
                </TextWebWrapper>
              </AlignLogoWeb>
            </ContentAlignLogo>
          </ContentLogo>
          <ContentImages>
            {images?.map((img, index) => (
              <Image
                src={img}
                alt="Portal Minha Ultragaz"
                isActive={index + 1 === imageActive}
              />
            ))}
          </ContentImages>
          <ContentLogin>
            <ContentAlign>
              <ContentLogoMobile>
                <AlignLogoMobile>
                  <TextLogoMobileWrapper>
                    <ImageTextWrapper>
                      <img
                        src={StoreFront}
                        alt="Portal Minha Ultragaz"
                        width={32}
                      />
                      <TitleMobileWrapper>
                        <h2>Portal</h2>
                        <h2>Minha Ultragaz</h2>
                      </TitleMobileWrapper>
                    </ImageTextWrapper>
                    <TextMobileWrapper>
                      <span>
                        Feito para moradores de condomínios e lojistas com
                      </span>
                      <span>medição individualizada</span>
                    </TextMobileWrapper>
                  </TextLogoMobileWrapper>
                </AlignLogoMobile>
              </ContentLogoMobile>
              <ContentLoginWrapper>
                <ContentAlignLogin>
                  <AcessarMI setShowModalRestPass={setShowModalRestPass} />
                </ContentAlignLogin>
                {showBoletoRapido && <FormBoletoRapido />}
              </ContentLoginWrapper>
            </ContentAlign>
          </ContentLogin>
        </Content>
      </Container>
      <ContentBanner>
        <Banner>
          <TextBanner>
            Está entrando em um apartamento/loja com Medição Individual?
          </TextBanner>
          <LinkBanner href="/troca-titularidade?tab=2">
            Realize a troca de titularidade
          </LinkBanner>
        </Banner>
        <Banner>
          <TextBanner>
            Está saindo de um apartamento/loja com Medição Individual?
          </TextBanner>
          <LinkBanner href="/troca-titularidade?tab=1">
            Solicite a suspensão
          </LinkBanner>
        </Banner>
        <Banner>
          <TextBanner>Quer solicitar o Ligue ou Religue do seu gás?</TextBanner>
          <LinkBanner href="/troca-titularidade?tab=3">
            Entenda e solicite
          </LinkBanner>
        </Banner>
      </ContentBanner>
      <ResetPassword
        setShowModal={setShowModalRestPass}
        showModal={showModalResetPass}
      />
    </>
  );
};

export default Login;
